import Vue from 'vue';

//Checkout

export const PageCheckout = Vue.component('page-checkout', require('./components/index/PageCheckout.vue'));
export const TabsCheckout = Vue.component('tabs-checkout', require('./components/index/TabsCheckout.vue'));
export const CartTable = Vue.component('cart-table', require('./components/index/CartTable'));
// export const CartProgressTable = Vue.component('cart-progress-table',require('./components/index/cart-table-subcomponents/CartTableProgress'));
export const AddTeacher = Vue.component('add-teacher', require('./components/index/AddTeacherComponent'));
export const PageThankYou = Vue.component('page-thank-you', require('./components/thankyou/PageThankYou.vue'));
export const PaypalBtn = Vue.component('paypal-donate-btn', require('./components/index/PayPalDonateBtn.vue'));


// WEBPACK FOOTER //
// ./resources/js/views/checkout/index.js